<!-- 谈话记录 -->
<template>
  <div class="Crisis_major_consult">
    
    <el-form style="padding: 20px;" :inline="true" :model="formInline" class="demo-form-inline">

      <el-form-item :label="$t('original.languages110')">
        <el-input v-model="Content" :placeholder="$t('original.languages490')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('original.languages445')" prop="campus">
        <el-select v-model="Campus" :placeholder="$t('original.languages3')">
          <el-option  :label="$t('original.languages114')" value=""></el-option>
          <el-option v-for="item in campus_list" :key="item.cDicEnglishValue" :label="item.cDicValue"
            :value="item.dicKey">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('original.languages170')" prop="region">
        <el-date-picker v-model="time_s" type="daterange" :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="状态" prop="campus">
        <el-select v-model="Status" placeholder="请选择状态">
          <el-option label="全部" value="0"></el-option>
          <el-option label="候补中" value="1"></el-option>
          <el-option label="已取消" value="2"></el-option>
          <el-option label="候补成功" value="3"></el-option>
        </el-select>
      </el-form-item>



      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{$t('original.languages470')}}</el-button>
        <el-button type="primary" @click="onSubmit2">重置</el-button>
      </el-form-item>

    </el-form>

    <div>

      <el-table v-loading="loadings" :data="data" style="width: 100%;margin-top:10px;width: 98%;margin-left: 1%;" :default-sort="{ prop: 'date', order: 'descending' }">

          <el-table-column :label="$t('original.name')">
            <template slot-scope="scope">
              <span>{{ scope.row.RealName }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.languages79')">
            <template slot-scope="scope">
              <span>{{ scope.row.UserID }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.languages462')">
            <template slot-scope="scope">
              <span> {{ scope.row.ScheduleDate }} </span>
            </template>
          </el-table-column>
          
          <el-table-column :label="$t('original.languages71')">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.languages491')">
            <template slot-scope="scope">
              <span>{{ scope.row.CreateTime }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.phone')">
            <template slot-scope="scope">
              <span> {{ scope.row.Phone }} </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.Id_number')">
            <template slot-scope="scope">
              <span>{{ scope.row.IDCard }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.languages492')">
            <template slot-scope="scope">
              <span v-if="scope.row.Status == '候补中'"   style="color: rgb(64, 158, 255);">{{ scope.row.Status }}</span>
              <span v-if="scope.row.Status == '已取消'"   style="color: rgb(214, 11, 34);">{{ scope.row.Status }}</span>
              <span v-if="scope.row.Status == '候补成功'" style="color: rgb(21, 191, 109);">{{ scope.row.Status }}</span>
            </template>
          </el-table-column>

        </el-table>

    </div>
    <!-- currentPage1 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page.sync="pageIndex"  :page-size="10" layout="total, prev, pager, next" :total="Counts">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Status:'0',
      time_s:[],
      campus_list: [],
      Campus: '',
      Content:'',
      ts:'',
      PaperList:[],
      dialogVisible:false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      fieldArray:[],
      SaveFlg: 1,
      value1: '',
      InterviewStatus: '4',
      loadings: true,
      interviewVisible: false,
      Counts:0,
      formInline: {
        UserID: '',
        Status: ''
      },
      Paperhead: {
        Name: '',
        Sex: '',
        DeptName: '',
        UserID: '',
        Result: '',
        PublishID: '',
        Remark: '',
        Age: '',
      },
      pageSize:10,
      pageIndex: 1,

      data:[]
    };
  },
  methods: {
    bg(res) {
      this.Paperhead.Name = res.RealName;
      this.Paperhead.Sex = res.Sex;
      this.$Http_Post('EmphasisClarification/GetPaperList', {PublishID: res.PublishID, UserID: res.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dialogVisible = true;
          this.PaperList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    gourl(res) {
      window.open(res.TencentLink);
    },
    handleClose(done) {
      this.$confirm(this.$t('original.languages60')).then(_ => {
          done();
        })
        .catch(_ => {
        });
    },
    handleSizeChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    onSubmit() {
      this.pageIndex = 1;
      this.loading();
    },
    onSubmit2() {
      this.pageIndex = 1;
      this.Content = '';
      this.Campus = '';
      this.time_s = []
      this.Status = '0'
      this.loading();
    },
    loading() {
      this.$Http_Post('/ConsultSubscribe/GetCandidateList',{ Content :this.Content, pageSize:10, pageIndex : this.pageIndex, Campus:this.Campus, From:this.time_s[0], To:this.time_s[1],Status:this.Status}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
          this.loadings = false;
          this.Counts = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
  mounted() {
    this.loading();
    this.Paperhead.Remark = JSON.parse(localStorage.getItem('userInfo')).UserName;
    this.$Http_Post('CrisisWarning/GetPageList', { TableName: '新生心理普测访谈记录表' }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.fieldArray = res.Data.FormConfigurations;
        this.SaveFlg = res.Data.SaveFlg;
      }
    });

    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 16 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.campus_list = res.Data;
      } else {
      }
    })
  },
  filters: {

  },
};
</script>
<style>
  .Crisis_major_consult{height: 100%;width: 100%;background-color: #fff;}
  tbody td{text-align: center !important;}
  .Crisis_major_consult .colrowspanbottomstyle {border-bottom: 1px solid rgba(225, 226, 227, 1);}
  .Crisis_major_consult .noneborder input {border: 0px;}
  .Crisis_major_consult .bottomborder input {border-bottom: 1px solid rgba(166, 166, 166, 1);}
  .Crisis_major_consult .el-dialog h2 {padding-top: 14px;margin-bottom: 14px;}
  .Crisis_major_consult .el-dialog .标题 {width: 100%;}
  .Crisis_major_consult .el-dialog .el-form>div {margin-left: 14px;}
  .Crisis_major_consult .el-dialog .输入框 input {width: initial;width: 400px;}
  .Crisis_major_consult .el-textarea__inner{height: 80px !important;}
  .Crisis_major_consult .el-dialog .el-input__inner {width: initial;}
  .el-dialog .填空题, .单选题, .时间选择, .文本域{padding: 6px;border: 1px solid rgb(235, 235, 235);margin-top: 4px;}
  .Crisis_major_consult .el-dialog .el-form-item__label {width: initial !important;display: inline-block;text-align: right;min-width: 90px;text-align: left;width: 132px !important;}
  .Crisis_major_consult .el-dialog  .el-textarea{width: 350%;}
  .Crisis_major_consult .el-dialog .el-form-item__content {margin-left: initial !important;display: inline-block;}
  .Crisis_major_consult .mild {padding: 0px 15px;background: rgba(29, 154, 255, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(29, 154, 255, 1);}
  .Crisis_major_consult .moderate {padding: 0px 15px;background: rgba(255, 193, 23, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px;color: rgba(255, 193, 23, 1);}

  .Crisis_major_consult .severe {
    padding: 0px 15px;
    background: rgba(255, 141, 26, 0.1);
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 0px;
    color: rgba(255, 141, 26, 1);
  }

  .Crisis_major_consult .well {
    padding: 0px 15px;
    background: rgba(21, 191, 109, 0.1);
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 0px;
    color: rgba(21, 191, 109, 1);
  }

  .Crisis_major_consult .urgency {
    padding: 0px 15px;
    background: rgba(191, 41, 21, 0.1);
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 0px;
    color: rgb(248, 4, 4);
  }


</style>
